export enum DailyContentType {
    StarterKit = "starterKit",
}

export enum DailyContentTag {
    Video = "video",
    Audio = "audio",
    Exercise = "exercise",
}

export enum DailyContentStatus {
    Active = "active",
    Inactive = "inactive"
}

export interface DailyContentRecordMeta {
    stepNumber?: number
}

export enum DailyContentRecordComponentType {
    Video = "video",
    Audio = "audio",
    Exercise = "exercise",
    Text = "text",
    OpenQuestion = "openQuestion"
}

export interface DailyContentRecordComponent {
    id: string;
    type: DailyContentRecordComponentType;
    url?: string; // for video, audio
    exerciseId?: string; // for exercise
    content?: string // for text, open-question
}

export interface DailyContentRecord {
    id: string;
    type: DailyContentType;
    status: DailyContentStatus;
    title: string;
    duration: number;
    tag: DailyContentTag;
    meta: DailyContentRecordMeta;
    components: DailyContentRecordComponent[];
    cta: string;
    dateCreated: Date;
    lastUpdated: Date;
}

// type of data returned to clients while fetching in MGS
export interface DailyContent {
    [DailyContentType.StarterKit]: Array<
        Pick<DailyContentRecord, 'id' | 'title' | 'tag' | 'duration'> & { isDone: boolean }
    >;
}

// type of daily_content column inside account_information table
export type AccountDailyContent = Record<string, {
    id: string,
    stepNumber: number,
    payload?: Array<{ id: string; value: string }>
}>
